import React, { useContext, useEffect } from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import { zitoneoRouteDefinitions } from './property-partners-portal/zitoneo/utils/zitoneoRoutes';
import Cookie from './layout/cookiesConsent/CookieConsent';
import CookieConsentConditional from './layout/cookiesConsent/CookieConsentConditional';
import { scrollToTop } from './utils/usefulFunctions';
import ExternalPagesContainer from './externalPages/ExternalPagesContainer';
import PropertyContainer from './property-partners-portal/PropertyContainer';
import Login from './publicSections/login/Login';
import PublicSectionContainer from './layout/publicSection/PublicSectionContainer';
import FormForgotPassword from './publicSections/forgotPassword/FormForgotPassword';
import LandingContact from './publicSections/contact/LandingContact';
import routes from './utils/commonVariables/routes';
import ServiceDesk from './publicSections/serviceDesk/ServiceDesk';
import { ProviderServiceDesk } from './contexts/ServiceDeskContext';
import SignUp from './publicSections/signUp/SignUp';
import { ProviderSignUp } from './contexts/SignUpContext';
import { ProviderDashboard } from './contexts/DashboardContext';
import FastCheckIn from './publicSections/fastCheckIn/FastCheckIn';
import { ProviderFastCheckIn } from './contexts/FastCheckInContext';
import { ProviderContact } from './contexts/ContactContext';
import Contact from './publicSections/contact/Contact';
import Footer from './layout/footer/Footer';
import GeneralHeader from './layout/header/GeneralHeader';
import { menuPropertyPublic, menuPropertyPrivate } from './utils/menusData';
import { ContextGlobalFeatures } from './contexts/GlobalFeatures';
import BunnyLoading from './components/BunnyLoading';
import { useAuth } from './contexts/AuthContext';
import { initializeAppInsights } from './appInsights';
import RedirectToOwnerPortal from './utils/RedirectToOwnerPortal';

function App({ location }) {
    const { isAuthenticated } = useAuth();
    const { isExternalPage, isLoadingInterface } = useContext(
        ContextGlobalFeatures
    );

    const isPropertiesPage = location.pathname.includes('/your-property/');

    const isZitoneoDetailPage = location.pathname.includes(
        zitoneoRouteDefinitions.BASE_PATH
    );

    useEffect(() => {
        scrollToTop();
    }, [location.pathname]);

    useEffect(() => {
        initializeAppInsights();
    }, [isExternalPage]);

    return (
        <div className='App'>
            {isLoadingInterface ? (
                <BunnyLoading />
            ) : (
                <>
                    <GeneralHeader
                        isExternalPage={isExternalPage}
                        menuData={
                            isAuthenticated
                                ? menuPropertyPrivate
                                : menuPropertyPublic
                        }
                        isVisible={!isPropertiesPage && !isZitoneoDetailPage}
                    />
                    <Switch>
                        <Route
                            path='/redirect=/:token/:webToken/:sid/:rol/:IdHotelOwner/:encodedUsername'
                            render={props => (
                                <RedirectToOwnerPortal
                                    {...props}
                                    redirectTo={routes.landingPrivate}
                                />
                            )}
                        />
                        <Route
                            path='/redirectFromHotel=/:token/:webToken/:sid/:rol/:IdHotelOwner/:encodedUsername/:idSupplierHotel'
                            render={props => (
                                <RedirectToOwnerPortal
                                    {...props}
                                    redirectTo={routes.zitoneoHotelServices(
                                        props.match.params.idSupplierHotel
                                    )}
                                />
                            )}
                        />
                        <Route
                            path={routes.cookieConsent}
                            component={CookieConsentConditional}
                        />
                        <Route
                            path='/(property|owner-portal|your-property|zitoneo)'
                            render={props => (
                                // coloco aquí el provider para que se cargue al entrar en la zona privada y no se monte y desmonte todo el rato y no hacer peticiones innecesarias
                                <ProviderDashboard>
                                    <PropertyContainer {...props} />
                                </ProviderDashboard>
                            )}
                        />
                        <Route
                            path={routes.fastCheckIn}
                            render={() => (
                                <PublicSectionContainer>
                                    <ProviderFastCheckIn>
                                        <FastCheckIn />
                                    </ProviderFastCheckIn>
                                </PublicSectionContainer>
                            )}
                        />
                        <Route
                            path={routes.forgotPassword}
                            render={() => (
                                <PublicSectionContainer>
                                    <FormForgotPassword />
                                </PublicSectionContainer>
                            )}
                        />
                        <Route
                            path={routes.contactForm}
                            render={() => (
                                <PublicSectionContainer>
                                    <ProviderContact>
                                        <Contact />
                                    </ProviderContact>
                                </PublicSectionContainer>
                            )}
                        />
                        <Route
                            path={routes.contact}
                            render={() => (
                                <PublicSectionContainer>
                                    <LandingContact />
                                </PublicSectionContainer>
                            )}
                        />
                        <Route
                            path={routes.serviceDesk}
                            render={() => (
                                <PublicSectionContainer>
                                    <ProviderServiceDesk>
                                        <ServiceDesk />
                                    </ProviderServiceDesk>
                                </PublicSectionContainer>
                            )}
                        />
                        <Route
                            path={routes.signUp}
                            render={() => (
                                <PublicSectionContainer>
                                    <ProviderSignUp>
                                        <SignUp />
                                    </ProviderSignUp>
                                </PublicSectionContainer>
                            )}
                        />
                        <Route path={routes.login} component={Login} />
                        <Route
                            path='/'
                            render={props => (
                                <ExternalPagesContainer {...props} />
                            )}
                        />
                    </Switch>
                    {!isZitoneoDetailPage && (
                        <Footer isExternalPage={isExternalPage} />
                    )}
                    <Cookie />
                </>
            )}
        </div>
    );
}

export default withRouter(App);
